<template>
    <div
        class="flex flex-col items-start gap-2 flex-1 px-4 py-5 sm:p-4 overflow-hidden md:rounded-lg"
    >
        <dt class="flex py-1 items-center self-stretch">
            <div class="flex justify-between items-start w-full">
                <div class="text-lg font-medium text-slate-800 dark:text-slate-100">Cards</div>
                <div class="text-sm font-medium text-slate-800 dark:text-slate-100">
                    <a
                        href="/wallet/"
                        class="block -mt-1"
                        id="hs-dashboard-view-cards"
                    >
                        <icon icon="arrow" />
                    </a>
                </div>
            </div>
        </dt>
        <dashboard-stat-skeleton v-if="loading" />
        <dd v-else class="mt-1 text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
            <template v-if="open === 0 && closed === 0">
                <div class="flex items-start self-stretch gap-16">
                    <div class="flex flex-col">
                        <span class="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
                            <hr
                                class="w-4 border-slate-800 dark:border-slate-100 border-b-2 rounded-md text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3 mt-6"
                            />
                        </span>
                        <span class="text-xs font-medium text-gray-400 dark:text-gray-500">
                            Open
                        </span>
                    </div>
                    <div class="flex flex-col pr-5">
                        <span class="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
                            <hr
                                class="w-4 border-slate-800 dark:border-slate-100 border-b-2 rounded-md text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3 mt-6"
                            />
                        </span>
                        <span class="text-xs font-medium text-gray-400 dark:text-gray-500">
                            Closed
                        </span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="flex items-start self-stretch gap-16">
                    <div class="flex flex-col">
                        <span class="text-3xl font-medium text-slate-800 dark:text-slate-100 mb-3">
                            <template v-if="open > 0 && open !== null">
                                <count-up
                                    :end-val="open"
                                    :key="'open-' + open"
                                ></count-up>
                            </template>
                            <template v-else>
                                <hr
                                    class="w-4 border-slate-800 dark:border-slate-100 border-b-2 rounded-md text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3 mt-6"
                                />
                            </template>
                        </span>
                        <span class="text-sm font-medium text-slate-500 dark:text-slate-400">
                            Open
                        </span>
                    </div>
                    <div class="flex flex-col pr-5">
                        <span class="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
                            <template v-if="closed > 0 && closed !== null">
                                <count-up
                                    :end-val="closed"
                                    :key="'closed-' + closed"
                                ></count-up>
                            </template>
                            <template v-else>
                                <hr
                                    class="w-4 border-slate-800 dark:border-slate-100 border-b-2 rounded-md text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3 mt-6"
                                />
                            </template>
                        </span>
                        <span class="text-sm font-medium text-slate-500 dark:text-slate-400">
                            Closed
                        </span>
                    </div>
                </div>
            </template>
        </dd>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { useDashboardStore } from '@/store/dashboard';
import CountUp from 'vue-countup-v3';
import Icon from '../../ui/icon/icon.vue';
import DashboardStatSkeleton from './dashboard-stat-skeleton.vue';

export default {
    props: [],
    components: {
        Icon,
        CountUp,
        DashboardStatSkeleton,
    },
    computed: {
        ...mapState(useDashboardStore, ['loading', 'open', 'closed']),
    },
    data: () => ({}),
    methods: {},
    created() {},
    mounted() {},
};
</script>
